import { ComposeViewState } from 'owa-mail-compose-store';
import { AttachmentSuggestionsMenuItems } from 'owa-attachment-suggestions';
import logAttachButtonClickedDatapoint from './logAttachButtonClickedDatapoint';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import getSuggestedAttachmentMessageFromComposeViewState from 'owa-mail-compose-actions/lib/utils/getSuggestedAttachmentMessageFromComposeViewState';

export function logAttachOrInsertMenuOpened(
    composeViewState: ComposeViewState,
    getAttachmentSuggestionsMenuItems: () => AttachmentSuggestionsMenuItems | null,
    buttonsList: string,
    referenceAttachmentsSupported: boolean,
    classicAttachmentsSupported: boolean
) {
    logAttachButtonClickedDatapoint(composeViewState.referenceItemId?.Id);

    const referenceItem = getMailStore().items.get(composeViewState.referenceItemId?.Id);
    const attachmentSuggestionsMenuItems = getAttachmentSuggestionsMenuItems();
    attachmentSuggestionsMenuItems?.onMenuOpened(
        true /* shouldUseSuggestions */,
        referenceItem,
        composeViewState.composeId,
        buttonsList,
        referenceAttachmentsSupported,
        classicAttachmentsSupported,
        getSuggestedAttachmentMessageFromComposeViewState(composeViewState)
    );
}
